import { render, staticRenderFns } from "./ProductPurchasedPerMonthBanner.vue?vue&type=template&id=053a468f&"
import script from "./ProductPurchasedPerMonthBanner.js?vue&type=script&lang=js&"
export * from "./ProductPurchasedPerMonthBanner.js?vue&type=script&lang=js&"
import style0 from "./ProductPurchasedPerMonthBanner.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductPurchasedPerMonthBanner.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fcvb%2Fcomponents%2Fproduct%2FProductPurchasedPerMonthBanner%2FProductPurchasedPerMonthBanner.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports